import { ColDef, ICellRendererParams } from 'ag-grid-community';
import {
  createBadgeCol,
  createCustomCol,
  createDateHasAllTimeCol,
  createDetailButtonColV2,
  createIdCol,
  createTypoCol,
} from '@/src/helpers/agColumnHelper';
import { CreditHistoryDto } from '@/src/models/CreditHistoryDto';
import { UNIT_STRINGS } from '@/src/constants/unit';

export const creditHistoryListColumn = (
  onDetailClick: (id: number) => void,
): ColDef[] => [
  createIdCol(),
  createDateHasAllTimeCol({
    field: 'createdAt',
    size: 'md',
    flex: 1,
    headerName: '등록 일시',
  }),
  createCustomCol({
    field: 'nick',
    cellRenderer: ({ data }: ICellRendererParams) =>
      data?.customer?.nick || '-',
    size: 'sm',
    headerName: '닉네임',
  }),
  createTypoCol({
    field: 'category',
    size: 'sm',
    headerName: '상위 카테고리',
  }),
  createCustomCol({
    field: 'creditTitle',
    cellRenderer: ({ data }: ICellRendererParams<CreditHistoryDto>) => {
      return data?.creditTemplate?.title || data?.subDescription || '직접 입력';
    },
    size: 'lg',
    flex: 2,
    headerName: '하위 카테고리',
  }),
  createBadgeCol({
    field: 'type',
    size: 'sm',
    options: [
      {
        label: '적립',
        value: '적립',
        color: 'lightGreen',
      },
      {
        label: '사용',
        value: '사용',
        color: 'lightPurple',
      },
      {
        label: '차감',
        value: '차감',
        color: 'lightRed',
      },
      {
        label: '소멸',
        value: '소멸',
        color: 'lightGray',
      },
    ],
    headerName: '타입',
  }),
  createCustomCol({
    field: 'value',
    size: 'sm',
    cellRenderer: ({ value, data }: ICellRendererParams) =>
      data?.type === '적립'
        ? `+${Number(value).toLocaleString()}`
        : `${Number(value).toLocaleString()}`,
    headerName: `크레딧(${UNIT_STRINGS.CREDIT})`,
  }),
  createCustomCol({
    field: 'adminName',
    cellRenderer: (params: ICellRendererParams) => {
      return params?.data?.administrator?.name || '시스템';
    },
    size: 'sm',
    headerName: '등록 관리자',
  }),
  createDetailButtonColV2(onDetailClick),
];
